import { useCallback, useEffect, useState } from "react";
import useApi from "../Api/Api";

const useEventComparisonAll = () => {
  const api = useApi();
  const [allEvents, setAllEvents] = useState([]);
  const [sortFilterAll, setSortFilterAll] = useState("date");
  const [searchFilterAll, setSearchFilterAll] = useState();
  const [attendanceMinAll, setAttendanceMinAll] = useState();
  const [attendanceMaxAll, setAttendanceMaxAll] = useState();
  const [grossMinAll, setGrossMinAll] = useState();
  const [grossMaxAll, setGrossMaxAll] = useState();

  const getEvents = useCallback(() => {
    let queryParams = {};
    if (sortFilterAll) {
      queryParams.sort = sortFilterAll;
    }
    if (searchFilterAll) {
      queryParams.query = searchFilterAll;
    }
    if (attendanceMinAll != null) {
      queryParams.attendance_min = attendanceMinAll;
    }
    if (attendanceMaxAll != null) {
      queryParams.attendance_max = attendanceMaxAll;
    }
    if (grossMinAll != null) {
      queryParams.gross_min = grossMinAll;
    }
    if (grossMaxAll != null) {
      queryParams.gross_max = grossMaxAll;
    }
    const queryString = Object.keys(queryParams)
      .map((param) => `${param}=${queryParams[param]}`)
      .join("&");
    // sort is always present; any additional key means an active filter
    const hasActiveFilter = Object.keys(queryParams).length > 1;
    if (hasActiveFilter) {
      api.get(`/events/compare?${queryString}`).then((r) => {
        setAllEvents(r.data);
      });
    }
  }, [api, searchFilterAll, sortFilterAll, attendanceMinAll, attendanceMaxAll, grossMinAll, grossMaxAll]);

  useEffect(() => {
    setAllEvents([]);
  }, []);

  useEffect(() => {
    getEvents();
  }, [getEvents]);

  allEvents.forEach((event) => {
    const [year, month, day] = event.date.split("T")[0].split("-");
    event.formattedDate = `${month}/${day}/${year}`;
  });

  return {
    allEvents,
    setSortFilterAll,
    setSearchFilterAll,
    setAttendanceMinAll,
    setAttendanceMaxAll,
    setGrossMinAll,
    setGrossMaxAll,
  };
};

export default useEventComparisonAll;
